import React from "react";

function ViewCheckIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="21"
      height="21"
      fill="none"
      viewBox="0 0 21 21">
      <path
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.2"
        d="M10.413 18.553c4.584 0 8.334-3.75 8.334-8.333s-3.75-8.333-8.334-8.333c-4.583 0-8.333 3.75-8.333 8.333s3.75 8.333 8.333 8.333z"></path>
      <path
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.2"
        d="M6.873 10.218l2.358 2.358 4.725-4.717"></path>
    </svg>
  );
}

export default ViewCheckIcon;
